/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author ILya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { Fragment } from 'react';

import { useSelector } from 'react-redux';

import PageTitle, { renderDropFilterButton } from '@components/common/PageTitle/PageTitle';
import { API_REPORTS_SUBSCRIBER_EDIT_META } from '@modules/app/Api';
import { makeSelectTranslationPageSubscriberMobile } from '@modules/internationalization/intSelectors';
import { TableDensity, useTableFilterApi } from '@modules/table';
import { tableDataCountSelector, tableMetaFilterSelector } from '@modules/table/selectors';

import { TABLE_FILTER_AVAILABLE_NAMES } from '../constants';

export const TableReportsSubscribersTitle = () => {

    const tReportsSubscribers = useSelector(makeSelectTranslationPageSubscriberMobile());

    const count = useSelector(tableDataCountSelector);

    /* Сбросить фильтр */
    const { drop } = useTableFilterApi();
    const selectedFilters = useSelector(
        tableMetaFilterSelector(API_REPORTS_SUBSCRIBER_EDIT_META, TABLE_FILTER_AVAILABLE_NAMES),
    );

    return (
        <Fragment>
            <PageTitle count={count} dataName="subscriber" title={tReportsSubscribers.title.header}>
                {
                    /* Сбросить фильтр */
                    !!Object.keys(selectedFilters).length
                    && renderDropFilterButton({
                        onClick: drop,
                        value: tReportsSubscribers.title.dropFilters,
                    })
                }
                <TableDensity />
            </PageTitle>
        </Fragment>

    );
};

